import { call, put, takeLatest } from "redux-saga/effects";
import AppService from "../../services/AppService";
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  verifyOtpRequest,
  verifyOtpSuccess,
  verifyOtpFailure,
  verifyTokenRequest,
  verifyTokenSuccess,
  verifyTokenFailure,
  resendOtpRequest,
  resendOtpSuccess,
  resendOtpFailure,
} from "../slice/authSlice";

// 1. Handle Login (Send OTP)
function* handleLogin(action) {
  try {
    const { mobile } = action.payload;
    const response = yield call(AppService.loginUser, action.payload); 
    console.log('--handleLogin--', response);

    if (!response.success) {
      yield put(loginFailure(response.message || "Login failed"));
    } else {
      yield put(loginSuccess({
        user_id: response.data.user.id,
        session_id: response.data.otp_session.session_id,
        mobile: mobile,
      }));
    }
  } catch (error) {
    console.log(error);
    yield put(loginFailure(error.message));
  }
}

// 2. Handle Verify OTP
function* handleVerifyOtp(action) {
  try {
    const response = yield call(AppService.verifyOtp, action.payload);
    console.log('--handleVerifyOtp--', response);

    if (!response.success) {
      yield put(verifyOtpFailure(response.message || "Invalid OTP"));
    } else {
      yield put(verifyOtpSuccess({
        user: response.data.user,
        token: response.data.token
      }));
    }
  } catch (error) {
    console.log(error);
    yield put(verifyOtpFailure(error.message));
  }
}

// 3. Handle Resend OTP
function* handleResendOtp(action) {
  try {
    const { user_id } = action.payload;
    const response = yield call(AppService.resendOtp, { user_id });
    console.log('--handleResendOtp--', response);

    if (!response.success) {
      yield put(resendOtpFailure(response.message));
    } else {
      yield put(resendOtpSuccess({
        session_id: response.data.otp_session.session_id
      }));
    }
  } catch (error) {
    console.log(error);
    yield put(resendOtpFailure(error.message));
  }
}

function* handleVerifyToken(action) {
  try {
    const response = yield call(AppService.verifyToken, action.payload);
    console.log('--handleVerifyToken--',response);
    if (!response.success) {
      yield put(verifyTokenFailure(response.message || "Invalid token"));
    } else {
      yield put(verifyTokenSuccess({
        user: response.data.user,
        token: action.payload.token,
      }));
    }

  } catch (error) {
    yield put(verifyTokenFailure(error.message));
  }
}

// Watcher Saga
export default function* authSaga() {
  yield takeLatest(loginRequest.type, handleLogin);
  yield takeLatest(verifyOtpRequest.type, handleVerifyOtp);
  yield takeLatest(resendOtpRequest.type, handleResendOtp);
  yield takeLatest(verifyTokenRequest.type, handleVerifyToken);
}